import { useEffect } from 'react'
import { useTheme } from '@mui/material/styles'

/** Paints the whole iframe page background, and restores it on unmount. */
export default function usePageBackground(): void {
  const theme = useTheme()
  useEffect(() => {
    const previous = document.body.style.background
    document.body.style.background = theme.palette.surface.page
    return () => {
      document.body.style.background = previous
    }
  }, [theme])
}
